import type {SlotGameStore} from "@gamzix/slot_core";

import {CONST} from "../../../src/const";

class GameSymbolView extends SlotGame.src.component.ReelsetComponent.src.SymbolView {

    public setOverlayView() {
        if (!GameSymbolView.bonusGameConfig.coinSymbolIds.includes(this.id)) return;

        const hasJackpot = Object.values(CONST.JACKPOT).includes(this.store.gameData.reels[this.reelId][this.rowId]?.value);
        let value = this.store.gameData.reels[this.reelId][this.rowId]?.value;

        if (this.rowId < 0) {
            const randomValueIndex = Math.floor(Math.random() * (ReelsetComponent.src.SymbolView.bonusGameConfig.fakeValues.length - 1));
            value = ReelsetComponent.src.SymbolView.bonusGameConfig.fakeValues[randomValueIndex];
        }

        switch (String(value)) {
            case CONST.JACKPOT.BRONZE_MULTIPLIER.toString(): {
                this.setOverlayImage('coin_bronze');
                break;
            }
            case CONST.JACKPOT.SILVER_MULTIPLIER.toString(): {
                this.setOverlayImage('coin_silver');
                break;
            }
            case CONST.JACKPOT.GOLD_MULTIPLIER.toString(): {
                this.setOverlayImage('coin_gold');
                break;
            }
            case "?" : {
                this.setOverlayImage('coin_mystery');
                break;
            }
            default: {
                if (ReelsetComponent.src.SymbolView.bonusGameConfig.coinSymbolIds.includes(this.id)) {
                    const textConfigView = ReelsetComponent.src.SymbolView.symbolTextConfig.view;
                    this.removeOverlayView();
                    this.overlayView = game.builder.create(textConfigView);

                    if (!value) return;
                    this.overlayView.options.text = this.store.toFormatMoney(value * this.store.gameData.bet);
                    this.overlayView.updateViewOptions();

                    this.view.addChild(this.overlayView);
                }
            }
        }
    }

    setOverlayImage(name, scale = { x: 1, y: 1 }) {
        this.removeOverlayView();
        this.overlayView = game.builder.create({type: "Sprite", texture: name, scale: scale});
        this.overlayView.updateViewOptions();
        this.view.addChild(this.overlayView);
    }

    async playReplace() {
        if (this.id == CONST.SYMBOLS.COIN) {
            let value = this.store.gameData.reels[this.reelId][this.rowId]?.value;

            game.emit("GameSymbolView.START_REPLACE_MYSTERY_COIN");
            await game.utils.GameUtils.playScaleToAnimation(this.overlayView, {scaleFrom: 1, scaleTo: 0, time: 300});

            switch (String(value)) {
                case CONST.JACKPOT.BRONZE_MULTIPLIER.toString():
                    this.setOverlayImage('coin_bronze', {x: 0, y: 0});
                    break;
                case CONST.JACKPOT.SILVER_MULTIPLIER.toString():
                    this.setOverlayImage('coin_silver', {x: 0, y: 0});
                    break;
                case CONST.JACKPOT.GOLD_MULTIPLIER.toString():
                    this.setOverlayImage('coin_gold', {x: 0, y: 0});
                    break;
            }

            await game.utils.GameUtils.playScaleToAnimation(this.overlayView, {scaleFrom: 0, scaleTo: 1, time: 300});
        }
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }
}

SlotGame.src.component.ReelsetComponent.src.SymbolView = GameSymbolView;